import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type PasswordChangeForcePageStore } from 'pages/auth/pages/passwordChangeForce/store/passwordChangeForcePageStore'

export const PasswordChangeForcePageContext = createContext<PasswordChangeForcePageStore | null>(
  null
)

export const usePasswordChangeForcePageContext = () => {
  const context = useContext(PasswordChangeForcePageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with PasswordChangeForcePageContext'
    )

  return context
}

type IProviderPasswordChangeForcePageProps = {
  value: PasswordChangeForcePageStore
  children: ReactNode
}

export const ProviderPasswordChangeForcePage: FC<IProviderPasswordChangeForcePageProps> = ({
  value,
  children,
}) => {
  return (
    <PasswordChangeForcePageContext.Provider value={value}>
      {children}
    </PasswordChangeForcePageContext.Provider>
  )
}
